import { Card, Typography, Box, Grid, Tooltip } from '@mui/material';
import moment from 'moment';
import { Clock } from 'react-feather';
import { getScreenSize, zerosEsquerda } from 'src/utils/getUtils';
import PlatformSalesIcon from '../PlatformSalesIcon';
import useStyles from './styles';
import { useNotification } from 'src/context/notification-context.js';
import { formatData, formatDataHoraMinuto } from 'src/utils/dateUtils';
import ShippingStatusIcon from '../ShippingStatusIcon';
import { getPendingStatus } from 'src/utils/systemUtils';
import FlatIcon, { FlatIconOptions } from 'src/components/ui/FlatIcon';

function SalesOrderCard({ orders = [] }) {
  const classes = useStyles();
  const { notificationHeight } = useNotification();

  function diffHours(data1, data2) {
    let dif =
      Date.UTC(data1.getYear(), data1.getMonth(), data1.getDate(), 0, 0, 0) -
      Date.UTC(data2.getYear(), data2.getMonth(), data2.getDate(), 0, 0, 0);

    dif = Math.abs(dif / 1000 / 60 / 60);
    let difH = Math.abs(data2.getHours() - data1.getHours());
    let difM = Math.abs(data2.getMinutes() - data1.getMinutes());

    return `${zerosEsquerda(dif + difH, 2)}:${zerosEsquerda(difM, 2)}`;
  }

  function ItemCard({ item, key }) {
    return (
      <Box key={key}>
        <Card
          className={classes.cardRowStyle}
          sx={{ mt: 0.625 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '5px' }}>
            <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
              <PlatformSalesIcon
                platform={item?.marketplace?.name.split('_')[0].toLowerCase()}
                width={50}
                height={50}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: 14 }}>{item?.marketplace?.name}</Typography>
                  <Typography
                    align='right'
                    sx={{ fontSize: 14 }}>
                    {item.order_id}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {item?.shipping?.method_name}
                  </Typography>
                  <Typography
                    align='right'
                    sx={{ fontSize: 12 }}>
                    {item?.order_id_marketplace}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'right' }}>
                  <Typography
                    align='right'
                    sx={{ fontSize: 12 }}>
                    {formatDataHoraMinuto(item?.approved_at)}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '3px' }}>
              <ShippingStatusIcon
                status={getPendingStatus(item?.shipping?.estimated_handling_limit)}
                isMobile={true}
              />
              <Typography
                align='right'
                sx={{ fontSize: 12 }}>
                {item?.prioritized && (
                  <Tooltip title='Priorizado na expedição'>
                    <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: 1 }}>
                      <Typography sx={{ fontSize: 12 }}>Priorizado</Typography>
                      <FlatIcon
                        icon={FlatIconOptions.priority}
                        size={18}
                        style={{ marginLeft: 'auto' }}
                      />
                    </Box>
                  </Tooltip>
                )}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '3px' }}>
              <Typography sx={{ fontSize: 12 }}>
                Enviar até {formatData(item?.shipping?.estimated_handling_limit)}
              </Typography>
              <Typography
                align='right'
                sx={{ fontSize: 12, fontWeight: 700 }}>
                {item?.picking_info?.current_user}
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
    );
  }

  return (
    <Box>
      {orders.length > 0 ?
        orders.map((item, index) => (
          <ItemCard
            item={item}
            key={index}
          />
        ))
      : <ItemCard
          item={orders}
          key={1}
        />
      }
    </Box>
  );
}

export default SalesOrderCard;
